import type { MenuProps } from "@mui/material/Menu";
import Menu from "@mui/material/Menu";
import { useContext } from "react";
import PortalContainerContext from "./PortalContainerContext";

export default function AMenu({ children, ...props }: MenuProps) {
  const portalContainer = useContext(PortalContainerContext) ?? document.body;
  return (
    <Menu container={portalContainer} {...props}>
      {children}
    </Menu>
  );
}
